<template>
  <div>
    <v-row class="px-4">
      <v-col :cols="12">
        <v-text-field
          v-model="company.name"
          label="Company Name"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          v-model="company.invoiceNUmber"
          label="Invoice Number"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          v-model="company.primary_phone"
          label="Company Phone Number"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          v-model="company.primary_address"
          label="Company Physical Address"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          v-model="company.city"
          label="Company Physical Address"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          v-model="company.postal_code"
          label="Company Postal Code"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          v-model="company.email"
          label="Company Email"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          v-model="company.bank"
          label="Company Bank"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>
      <v-col :cols="12">
        <v-text-field
          v-model="company.account_number"
          label="Company Account Number"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>
      <v-col :cols="12">
        <v-text-field
          v-model="company.account_type"
          label="Company Account Type"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          v-model="company.vat_number"
          label="Company VAT Number"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          v-model="company.reg_number"
          label="Company Registration Number"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          v-model="company.tax_rate"
          type="number"
          label="Vat / Tax Percent %"
          @change="regeneratePDF()"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    company: {
      invoiceNUmber: "25-001",
      name: "Company Name",
      primary_phone: "012 345 6789",
      email: "company@gmail.com",
      primary_address: "123 Ken Street",
      city: "Durban",
      postal_code: "4001",
      bank: "First National Bank",
      account_number: "63248300231",
      account_type: "Cheque",
      vat_number: "4230240000",
      reg_number: "2002/032291/01",
      emis: "121-free-invoices-and-quotes",
      tax_rate: 0,
    },
  }),
  mounted() {
    this.regeneratePDF();
  },
  methods: {
    regeneratePDF() {
      this.$emit("company-updated", this.company);
    },
  },
};
</script>
